// extracted by mini-css-extract-plugin
export default {"root":"IconReviewUser_root__iRD-o"};